import femaleMoaning from'../m/moansStacy/femaleMoaning.js'
import femaleMoaning2 from'../m/moansStacy/femaleMoaning2.js'
import femaleMoaning3 from'../m/moansStacy/femaleMoaning3.js'
import femaleMoaning4 from'../m/moansStacy/femaleMoaning4.js'
import femaleMoaning5 from'../m/moansStacy/femaleMoaning5.js'
import femaleMoaning7 from'../m/moansStacy/femaleMoaning7.js'
import femaleMoaning10 from'../m/moansStacy/femaleMoaning10.js'
import femaleMoaning11 from'../m/moansStacy/femaleMoaning11.js'
import femaleMoaning12 from'../m/moansStacy/femaleMoaning12.js'
import femaleMoaning13 from'../m/moansStacy/femaleMoaning13.js'
import femaleMoaning14 from'../m/moansStacy/femaleMoaning14.js'
import femaleMoaning15 from'../m/moansStacy/femaleMoaning15.js'
import femaleMoaning16 from'../m/moansStacy/femaleMoaning16.js'
import femaleArousal10 from'../m/moansStacy/femaleArousal10.js'
import femaleArousal14 from'../m/moansStacy/femaleArousal14.js'
import femaleArousal21 from'../m/moansStacy/femaleArousal21.js'
import femaleArousal9 from'../m/moansStacy/femaleArousal9.js'
import ahem from'../m/ahem.js'
import wetPussy from'../m/moansStacy/wetPussy.js'
import orgasm7 from'../m/moansStacy/orgasm7.js'
import stacyLookingAtYou from'../images/stacyLookingAtYou.mp4'
import stacyLookingLeftSHY from'../images/stacyLookingLeftSHY.mp4'
import stacyLookingAtYouMouthOpen from'../images/stacyLookingAtYouMouthOpen.mp4'
import stacyLookingAtYouMouthOpenW from'../images/stacyLookingAtYouMouthOpenW.mp4'
import stacyLookingAtYouAngry from'../images/stacyLookingAtYouAngry.mp4'
import stacyLookingRight from'../images/stacyLookingRight.mp4'
import stacyLookingRightMouth from'../images/stacyLookingRightMouth.mp4'
import stacyLookingRightMouthW from'../images/stacyLookingRightMouthW.mp4'
import stacyLookingAtYouMouthOpen2 from'../images/stacyLookingAtYouMouthOpen2.mp4'
import stacyEyesClosed from'../images/stacyEyesClosed.mp4'
import stacyEyesClosed2 from'../images/stacyEyesClosed2.mp4'


//English
let dialogEducationFirstEn = [
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Yes, right here"},
      {text:"Now move it like I showed you"},
      {animationStart:true, animationSpeed:10},
      {text:"Yep, that's it", ambientStart:wetPussy, loopTimeAmbient:200, ambientSettings:[0.2, 1200]},
      {text:"But.."},
      {text:"Feels like it's a bit too intense for now..."},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"<i>Richard, try doing it a little slower</i>", wait:1000, rangeAppears:true},
    ]
  },
];
let dialogEducationEn = [
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Okay, let's try one more time", faceChange:stacyLookingAtYou},
      {text:"I am ready"},
      {animationStart:true, animationSpeed:10},
      {text:"Uh-huh", ambientStart:wetPussy, loopTimeAmbient:200, ambientSettings:[0.2, 1200]},
      {text:"But, feels like it's a bit too intense for now..."},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"<i>Very good, now try doing it a little slower</i>", wait:1000, rangeAppears:true},
    ]
  },
];
let dialogEducationSkipEn = [
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Okay, let's try one more time", faceChange:stacyLookingAtYou},
      {text:"I am ready"},
      {animationStart:true, animationSpeed:5},
      {text:"Yeah, that's it", ambientStart:wetPussy, loopTimeAmbient:200, ambientSettings:[0.2, 1200]},
      {text:"<i>Now, try doing it a little faster</i>", wait:1000, interfaceAppears:true}
    ]
  },
];

//Russian
let dialogEducationFirstRu = [
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ага, вот тут"},
      {text:"А теперь двигай рукой как я тебе показывала"},
      {animationStart:true, animationSpeed:10},
      {text:"Ага, вот так", ambientStart:wetPussy, loopTimeAmbient:200, ambientSettings:[0.2, 1200]},
      {text:"Только.."},
      {text:"Не так интенсивно.."},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"<i>Ричард, попробуй сбавить скорость</i>", wait:1000, rangeAppears:true},
    ]
  },
];
let dialogEducationRu = [
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Окей, давай попробуем еще разок", faceChange:stacyLookingAtYou},
      {text:"Можешь начинать.."},
      {animationStart:true, animationSpeed:10},
      {text:"Ах", ambientStart:wetPussy, loopTimeAmbient:200, ambientSettings:[0.2, 1200]},
      {text:"Пожалуйста, чуть нежнее..."},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"<i>Очень хорошо, только чуть помедленнее</i>", wait:1000, rangeAppears:true},
    ]
  },
];
let dialogEducationSkipRu = [
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Окей, давай попробуем еще разок", faceChange:stacyLookingAtYou},
      {text:"Можешь начинать.."},
      {animationStart:true, animationSpeed:5},
      {text:"Ага, вот так", ambientStart:wetPussy, loopTimeAmbient:200, ambientSettings:[0.2, 1200]},
      {text:"<i>Можно даже немного быстрее</i>", wait:1000, interfaceAppears:true}
    ]
  },
];

//FIRST stage

//English
let lowerSpeedArrEn=[
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"Yeah", soundEffectPre:femaleMoaning3, soundEffectVolume:0.4, faceChange:stacyLookingAtYou},
    {text:"This speed is perfect for now"},
    {text:"Mmmm", soundEffectPre:femaleArousal14, soundEffectVolume:0.2},
    {text:"Your hands feel so soft..."},
    {text:"I like it", soundEffectPre:femaleMoaning, soundEffectVolume:0.2, faceChange:stacyLookingAtYouMouthOpen2},
  ]
},
{
  char:"Prof. Ryder",  position:"right",
  phrases:[
    {text:"Richard, you are doing great!", soundEffectPre:ahem, soundEffectVolume:0.3, stageComplete:true, faceChange:stacyLookingRight},
    {text:"Keep it up!"},
    {text:"Please, keep in mind that"},
    {text:"These movements might not be very familiar to your hand", soundEffectPre:femaleMoaning3, soundEffectVolume:1, faceChange:stacyLookingAtYouMouthOpen2},
    {text:"So try to listen to Stacy, but don’t go too fast, or you'll get tired and have to start over!", staminaAppear:true, wait:1000},
    {text:"Сonsistency of stimulation is very important to achieve an orgasm!"},
  ]
},
{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"<i>You can do it a little faster now</i>", nextStage:true, wait:1000},
  ]
},
],
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"OH GOD!", vibration:[700], soundEffectPre:femaleMoaning10, soundEffectVolume:1, faceChange:stacyLookingAtYouMouthOpen},
    {text:"It's too much!!", soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingAtYouAngry},
    {text:"I need a good warm up before something like this!"},
    {text:"AH!", faceChange:stacyLookingAtYouMouthOpen},
    {text:"Do it sloOower!!"},
    {text:"PLEASE..."},
    {text:"IT ALMOST HURTS!!", wait:1000, soundEffectPre:femaleMoaning12, soundEffectVolume:0.2, faceChange:stacyLookingAtYouAngry},
    {text:"Just... do it as slow as you caAAN", wait:1000, checkPoint:true},
  ]
}
],
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"Uh-huh, a bit slower", faceChange:stacyLookingLeftSHY},
    {text:"You're almost there"},
    {text:"Just a little slower"},
    {text:"I like when it starts slow"},
    {text:"Even slower", soundEffectPre:femaleArousal21, soundEffectVolume:0.1},
    {text:"Aghhh...", vibration:[700], wait:500, faceChange:stacyLookingAtYouAngry},
    {text:"DICK!"},
    {text:"It feels like a torture!", wait:1000, soundEffectPre:femaleMoaning12, soundEffectVolume:0.2},
    {text:"Do it as slow as you can", wait:1000, checkPoint:true},

  ]
}
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, please, listen to Stacy"},
      {text:"Or I'll have to stop it"},
      {text:"Richard, my last warning!", vibration:[100,50,100], wait:1500},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }
],
[
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Oh, seems like something changed...", wait:500, soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingLeftSHY},
      {text:"Сan you please do as you did before?", wait:1500},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, are you here?", vibration:[100,50,100], wait:1000, faceChange:stacyLookingAtYouAngry},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }

]
];

//Russian
let lowerSpeedArrRu=[
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"Угу", soundEffectPre:femaleMoaning3, soundEffectVolume:0.4, faceChange:stacyLookingAtYou},
    {text:"Вот так вот"},
    {text:"Ммм", soundEffectPre:femaleArousal14, soundEffectVolume:0.2},
    {text:"У тебя такие нежные руки..."},
    {text:"Это очень приятно..", soundEffectPre:femaleMoaning, soundEffectVolume:0.2, faceChange:stacyLookingAtYouMouthOpen2},
  ]
},
{
  char:"Мисс Райдер",  position:"right",
  phrases:[
    {text:"Ричард, ты молодец!", soundEffectPre:ahem, soundEffectVolume:0.3, stageComplete:true, faceChange:stacyLookingRight},
    {text:"Так держать!"},
    {text:"Но не забывай"},
    {text:"Тебе нужно время чтобы привыкнуть к таким движениям", soundEffectPre:femaleMoaning3, soundEffectVolume:1, faceChange:stacyLookingAtYouMouthOpen2},
    {text:"Так что старайся слушать Стейси, но и не переусердствуй, а то устанешь и придется начать все сначала!", staminaAppear:true, wait:1000},
    {text:"Тут очень важно постоянство!"},
  ]
},
{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"<i>Теперь можешь немного ускориться</i>", nextStage:true, wait:1000},
  ]
},
],
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"БОЖЕ!", vibration:[700], soundEffectPre:femaleMoaning10, soundEffectVolume:1, faceChange:stacyLookingAtYouMouthOpen},
    {text:"Это слишком быстро!!", soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingAtYouAngry},
    {text:"Для такого мне нужна предварительная подготовка..."},
    {text:"АХ!", faceChange:stacyLookingAtYouMouthOpen},
    {text:"Давай ПомееедлЕнеЕее!!"},
    {text:"ПОЖАЛУЙСТА..."},
    {text:"МНЕ НЕПРИЯТНО!!", wait:1000, soundEffectPre:femaleMoaning12, soundEffectVolume:0.2, faceChange:stacyLookingAtYouAngry},
    {text:"ПожаАлуйтса, просто... замедлись", wait:1000, checkPoint:true},
  ]
}
],
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"Ага, немного медленнее", faceChange:stacyLookingLeftSHY},
    {text:"Еще немного.."},
    {text:"Чуть-чуть помедленнее"},
    {text:"Мне приятно, когда начинают медленно"},
    {text:"Еще медленнее", soundEffectPre:femaleArousal21, soundEffectVolume:0.1},
    {text:"Аргххх...", vibration:[700], wait:500, faceChange:stacyLookingAtYouAngry},
    {text:"ДИИК!"},
    {text:"Хватит меня дразнить!", wait:1000, soundEffectPre:femaleMoaning12, soundEffectVolume:0.2},
    {text:"Двигай рукой максимально медленно", wait:1000, checkPoint:true},

  ]
}
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, пожалуйста, слушай, что говорит Стейси"},
      {text:"Иначе нам придется остановиться"},
      {text:"Ричард, мое последнее предупреждение!", vibration:[100,50,100], wait:1500},
      {text:"Так, ладно, давайте сделаем перерыв", badEnd:true},
    ]
  }
],
[
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ох, кажется, что-то поменялось...", wait:500, soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingLeftSHY},
      {text:"Можешь делать как раньше?", wait:1500},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, ты тут?", vibration:[100,50,100], wait:1000, faceChange:stacyLookingAtYouAngry},
      {text:"Ладно, я думаю, стоит сделать перерыв", badEnd:true},
    ]
  }

]
];

//SECOND stage

//English
let secondStageArrEn=[
  [{
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Yes, yes, yes!", soundEffectPre:femaleMoaning14, soundEffectVolume:1, faceChange:stacyLookingAtYouMouthOpen},
      {text:"Just like that", faceChange:stacyLookingAtYouMouthOpen2},
      {text:"Oh my god"},
      {text:"It feels so good"},
      {text:"Mmmm", wait:500, soundEffectPre:femaleMoaning16, soundEffectVolume:0.3, faceChange:stacyEyesClosed2},
      {text:"Yeeaah"},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Oh, I can see you like it, Stacy", stageComplete:true},
      {text:"And Richard too...", wait:500},
      {text:"Do you want it faster?", wait:1000},
      {text:"Umm.. Stacy?", wait:1000},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Shit...", wait:500, soundEffectPre:femaleMoaning4, soundEffectVolume:1, faceChange:stacyLookingLeftSHY},
      {text:"Sorry, I think I just spaced out..."},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Oh, don't worry, darling, it's completely okay"},
      {text:"You can try making eye contact with me", wait:500},
      {text:"It'll help you concentrate on what's happening right now", wait:1000},
      {text:"Yes, very good, try not to look away...", wait:1000, faceChange:stacyLookingRight},
      {text:"And don't forget to guide Richard"},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"<i>Could you do it a little slower again?</i>",  wait:1000, nextStage:true},
    ]
  },
  ],
  [{
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Oh god!", soundEffectPre:femaleArousal10, soundEffectVolume:0.6, faceChange:stacyLookingAtYouMouthOpenW},
      {text:"That's intense!"},
      {text:"You better save your energy for the end"},
      {text:"I'm not...", soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingAtYouAngry},
      {text:"Mmmph"},
      {text:"Ready for something like this yet.."},
      {text:"Do it slower"},
      {text:"AH!", vibration:[700], faceChange:stacyLookingAtYouMouthOpen},
      {text:"Listen to me", soundEffectPre:femaleMoaning12, soundEffectVolume:0.2, faceChange:stacyLookingAtYouAngry},
      {text:"Just... do it slower", wait:1000, checkPoint:true},
    ]
  }
  ],
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"Please speed up a little...", faceChange:stacyLookingAtYou},
    {text:"It's too slow for now", soundEffectPre:femaleArousal21, soundEffectVolume:0.08},
    {text:"I usually like a bit of teasing...", wait:500, faceChange:stacyLookingLeftSHY},
    {text:"But now I want it faster so much!"},
    {text:"Pleeeease", soundEffectPre:femaleMoaning12, soundEffectVolume:0.2, faceChange:stacyLookingAtYou},
    {text:"Faster"},
    {text:"I don't think I'm gonna cum this century if you continue like this...", wait:1000, checkPoint:true, faceChange:stacyLookingAtYouAngry},
  ]
},
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, please, listen to Stacy"},
      {text:"Or I'll have to stop it"},
      {text:"Richard, my last warning!", vibration:[100,50,100], wait:1500},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }
],
[
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Oh, seems like something changed...", wait:500, soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingLeftSHY},
      {text:"Сan you please do as you did before?", wait:1500},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, are you here?", vibration:[100,50,100], wait:1000, faceChange:stacyLookingAtYouAngry},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }

],
];

//Russian
let secondStageArrRu=[
  [{
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Да-да-да!", soundEffectPre:femaleMoaning14, soundEffectVolume:1, faceChange:stacyLookingAtYouMouthOpen},
      {text:"Вот так", faceChange:stacyLookingAtYouMouthOpen2},
      {text:"Господи..."},
      {text:"Как же приятно"},
      {text:"Ммм-хммм", wait:500, soundEffectPre:femaleMoaning16, soundEffectVolume:0.3, faceChange:stacyEyesClosed2},
      {text:"Агааа..."},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Оу, Стейси, вижу, тебе начинает это нравится", stageComplete:true},
      {text:"И Ричарду, кажется, тоже...", wait:500},
      {text:"Может ускоримся?", wait:1000},
      {text:"Мм.. Стейси?", wait:1000},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ой, блин...", wait:500, soundEffectPre:femaleMoaning4, soundEffectVolume:1, faceChange:stacyLookingLeftSHY},
      {text:"Простите, я.. что-то задумалась..."},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Не переживай, дорогая, все хорошо"},
      {text:"Попробуй смотреть мне в глаза", wait:500},
      {text:"Это поможет тебе сконцентрироваться", wait:1000},
      {text:"Даа, вот так вот...", wait:1000, faceChange:stacyLookingRight},
      {text:"И не забывай говорить с Ричардом"},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"<i>Можешь опять немного помедленнее, пожалуйста?</i>",  wait:1000, nextStage:true},
    ]
  },
  ],
  [{
    char:"Стейси",  position:"center",
    phrases:[
      {text:"АХ!", soundEffectPre:femaleArousal10, soundEffectVolume:0.6, faceChange:stacyLookingAtYouMouthOpenW},
      {text:"Это быстро!"},
      {text:"Лучше побереги силы"},
      {text:"Я не...", soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingAtYouAngry},
      {text:"Мммпх"},
      {text:"Готова для такого сейчас.."},
      {text:"Медленнее"},
      {text:"АХ!", vibration:[700], faceChange:stacyLookingAtYouMouthOpen},
      {text:"Пожалуйста", soundEffectPre:femaleMoaning12, soundEffectVolume:0.2, faceChange:stacyLookingAtYouAngry},
      {text:"Дик"},
      {text:"Просто... делай это помедленнее", wait:1000, checkPoint:true},
    ]
  }
  ],
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"Пожалуйста, чуть быстрее...", faceChange:stacyLookingAtYou},
    {text:"Это слишком медленно", soundEffectPre:femaleArousal21, soundEffectVolume:0.08},
    {text:"Обычно мне нравится, когда меня немного дразнят...", wait:500, faceChange:stacyLookingLeftSHY},
    {text:"Но сейчас я  ОЧЕНЬ хочу кончить!"},
    {text:"Пожааааалуйста", soundEffectPre:femaleMoaning12, soundEffectVolume:0.2, faceChange:stacyLookingAtYou},
    {text:"Побыстрее"},
    {text:"Не думаю, что кончу в этом году, если ты и дальше будешь так делать...", wait:1000, checkPoint:true, faceChange:stacyLookingAtYouAngry},
  ]
},
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, пожалуйста, слушай, что говорит Стейси"},
      {text:"Иначе нам придется остановиться"},
      {text:"Ричард, мое последнее предупреждение!", vibration:[100,50,100], wait:1500},
      {text:"Так, ладно, давайте сделаем перерыв", badEnd:true},
    ]
  }
],
[
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ох, кажется, что-то поменялось...", wait:500, soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingLeftSHY},
      {text:"Можешь делать как раньше?", wait:1500},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, ты тут?", vibration:[100,50,100], wait:1000, faceChange:stacyLookingAtYouAngry},
      {text:"Ладно, я думаю, стоит сделать перерыв", badEnd:true},
    ]
  }

],
];

//THRID stage

//English

let thirdStageArrEn=[
  [{
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Yeah", soundEffectPre:femaleMoaning3, soundEffectVolume:1, faceChange:stacyLookingRightMouth},
      {text:"Right here"},
      {text:"Mmmhm", wait:500, soundEffectPre:femaleMoaning7, soundEffectVolume:0.8, faceChange:stacyLookingRight},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Yes, keep doing that, Richard", stageComplete:true},
      {text:"Your hand can rest for a bit now!", faceChange:stacyLookingAtYou},
      {text:"Oh, I can see you want it so much, don't you, Stacy?", wait:500},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Mmph", soundEffectPre:femaleMoaning16, soundEffectVolume:0.5, faceChange:stacyLookingRight},
      {text:"He's making me so wet..."},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"<i>Okay, Richard, now try doing it as fast as you can</i>", wait:1000, nextStage:true},
    ]
  },
],
  [{
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Aagh!", soundEffectPre:femaleMoaning, soundEffectVolume:1, faceChange:stacyLookingAtYouMouthOpenW},
      {text:"It's too fast!!"},
      {text:"I want it slower", faceChange:stacyLookingAtYou},
      {text:"Dick!", soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingAtYouAngry},
      {text:"DO IT SLOWER!!"},
      {text:"RICHARD PLEASE", vibration:[700]},
      {text:"IT ALMOST HURTS!!!", wait:1000, checkPoint:true},
    ]
  }
  ],
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"You're almost there", faceChange:stacyLookingRight},
    {text:"A bit slower", wait:1000},
    {text:"Please", faceChange:stacyLookingAtYou},
    {text:"Not so fast", soundEffectPre:femaleArousal21, soundEffectVolume:0.1, faceChange:stacyLookingAtYouAngry},
    {text:"Do it a little slower"},
    {text:"Dick, are you here?", wait:1000, checkPoint:true},
  ]
},
],
[{
  char:"Stacy",  position:"center",
  phrases:[
    {text:"It's a bit too slow", faceChange:stacyLookingRight},
    {text:"A little faster", wait:1000},
    {text:"I can barely feel it now", soundEffectPre:femaleArousal21, soundEffectVolume:0.1, faceChange:stacyLookingLeftSHY},
    {text:"Dick, do it faster", soundEffectPre:femaleMoaning12, soundEffectVolume:0.2, faceChange:stacyLookingAtYouAngry},
    {text:"Are you here?", wait:1000, checkPoint:true},
  ]
},
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, listen to Stacy"},
      {text:"Or I'll have to stop it", wait:1500},
      {text:"Richard, my last warning!", vibration:[100,50,100], wait:1000},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }
],
[
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Oh, seems like something changed...", wait:500, soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingAtYou},
      {text:"Сan you please do as you did before?", wait:1500},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, are you here?", vibration:[100,50,100], wait:1000, faceChange:stacyLookingAtYouAngry},
      {text:"All right, let's make a pause here", badEnd:true},
    ]
  }
]
];

//Russian
let thirdStageArrRu=[
  [{
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Да", soundEffectPre:femaleMoaning3, soundEffectVolume:1, faceChange:stacyLookingRightMouth},
      {text:"Вот так вот.."},
      {text:"Мммхм", wait:500, soundEffectPre:femaleMoaning7, soundEffectVolume:0.8, faceChange:stacyLookingRight},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Очень хорошо, Ричард...", stageComplete:true},
      {text:"Как раз дашь руке немного отдохнуть", faceChange:stacyLookingAtYou},
      {text:"Оу, я смотрю, ты вся в нетерпении, да, Стейси?", wait:500},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Мммпх", soundEffectPre:femaleMoaning16, soundEffectVolume:0.5, faceChange:stacyLookingRight},
      {text:"Я так этого хочу..."},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"<i>Хорошо, Ричард, теперь попробуй  максимально ускориться</i>", wait:1000, nextStage:true},
    ]
  },
],
  [{
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ааргх!", soundEffectPre:femaleMoaning, soundEffectVolume:1, faceChange:stacyLookingAtYouMouthOpenW},
      {text:"Слишком быстро!!"},
      {text:"Помедленнее", faceChange:stacyLookingAtYou},
      {text:"ДИК!", soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingAtYouAngry},
      {text:"МЕДЛЕННЕЕ!!"},
      {text:"ДИК, ПОЖАЛУЙСТА", vibration:[700]},
      {text:"МНЕ БОЛЬНО!!!", wait:1000, checkPoint:true},
    ]
  }
  ],
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"Угу, почти", faceChange:stacyLookingRight},
    {text:"Только немного помедленнее", wait:1000},
    {text:"Пожалуйста..", faceChange:stacyLookingAtYou},
    {text:"Не так быстро", soundEffectPre:femaleArousal21, soundEffectVolume:0.1, faceChange:stacyLookingAtYouAngry},
    {text:"Еще медленнее"},
    {text:"Дик, ты тут?", wait:1000, checkPoint:true},
  ]
},
],
[{
  char:"Стейси",  position:"center",
  phrases:[
    {text:"Это слишком медленно", faceChange:stacyLookingRight},
    {text:"Чуть побыстрее", wait:1000},
    {text:"Я почти ничего не чувствую", soundEffectPre:femaleArousal21, soundEffectVolume:0.1, faceChange:stacyLookingLeftSHY},
    {text:"Пожалуйста, побыстрее", soundEffectPre:femaleMoaning12, soundEffectVolume:0.2, faceChange:stacyLookingAtYouAngry},
    {text:"Дик, ты тут?", wait:1000, checkPoint:true},
  ]
},
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, пожалуйста, слушай, что говорит Стейси"},
      {text:"Иначе нам придется остановиться"},
      {text:"Ричард, мое последнее предупреждение!", vibration:[100,50,100], wait:1500},
      {text:"Так, ладно, давайте сделаем перерыв", badEnd:true},
    ]
  }
],
[
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Ох, кажется, что-то поменялось...", wait:500, soundEffectPre:femaleArousal21, soundEffectVolume:0.3, faceChange:stacyLookingAtYou},
      {text:"Можешь делать как раньше?", wait:1500},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, ты тут?", vibration:[100,50,100], wait:1000, faceChange:stacyLookingAtYouAngry},
      {text:"Ладно, я думаю, стоит сделать перерыв", badEnd:true},
    ]
  }

],
];

//FOURTH stage

//English
let fourthStageArrEn=[
  [
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Yes, very good", wait:800, stageComplete:true, soundEffectPre:femaleMoaning14, soundEffectVolume:0.7, faceChange:stacyLookingRightMouthW},
      {text:"<i>And now slow down to the lowest speed</i>", wait:1500, nextStage:true},
    ]
  },
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard?", faceChange:stacyLookingRight},
      {text:"Try doing it as fast as you can", vibration:[100,50,100], wait:1500},
      {text:"Richard, are you here?", badEnd:true, faceChange:stacyLookingAtYouAngry},
    ]
  }
]
];

//Russian
let fourthStageArrRu=[
  [
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Вот так, очень хорошо!", wait:800, stageComplete:true, soundEffectPre:femaleMoaning14, soundEffectVolume:0.7, faceChange:stacyLookingRightMouthW},
      {text:"<i>А теперь максимально замедлиться</i>", wait:1500, nextStage:true},
    ]
  },
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард?", faceChange:stacyLookingRight},
      {text:"Постарайся двигаться так быстро, как только можешь", vibration:[100,50,100], wait:1500},
      {text:"Ричард, ты здесь?", badEnd:true, faceChange:stacyLookingAtYouAngry},
    ]
  }
]
];

//FIFTH stage

//English
let fifthStageArrEn=[
  [
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Mm-hmm", wait:800, stageComplete:true, soundEffectPre:femaleMoaning2, soundEffectVolume:0.6, faceChange:stacyEyesClosed},
      {text:"Okay, now... umm", wait:1000},
      {text:"Let me show you", wait:500, guideStart:true},
      {text:"Just like that, speeding up and slowing down, speeding up and slowing down", wait:1000, soundEffectPre:femaleArousal9, soundEffectVolume:0.7, ambientChangeSettings:[0.5, 1000], faceChange:stacyLookingRight},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Miss... Ryder...?!", wait:200, faceChange:stacyLookingRightMouth},
      {text:"It's just a dream, right?...", wait:500, faceChange:stacyLookingLeftSHY},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Yes, Richard, very good!", wait:1000, guideFinish:true, faceChange:stacyLookingRightMouth},
      {text:"<i>Keep moving like that really fast, speed up and then slow down and so on</i>", wait:1500, nextStage:true},
    ]
  },
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Slow down, please", faceChange:stacyLookingRightMouth},
      {text:"Try doing it as slow as you can", vibration:[100,50,100], wait:1500},
      {text:"Richard, are you here?", badEnd:true, faceChange:stacyLookingAtYouAngry},
    ]
  }
]
];

//Russian
let fifthStageArrRu=[
  [
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Мм-хмм", wait:800, stageComplete:true, soundEffectPre:femaleMoaning2, soundEffectVolume:0.6, faceChange:stacyEyesClosed},
      {text:"Хорошо... Так, теперь.. ммм", wait:1000},
      {text:"Дай-ка я тебе покажу", wait:500, guideStart:true},
      {text:"Вот так, ускоряешься и замедляешься, ускоря-я-яешься... И-и-и замедля-я-яешься..", wait:1000, soundEffectPre:femaleArousal9, soundEffectVolume:0.7, ambientChangeSettings:[0.5, 1000], faceChange:stacyLookingRight},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Мисс... Райдер...?!", wait:200, faceChange:stacyLookingRightMouth},
      {text:"Мне это снится, да?...", wait:500, faceChange:stacyLookingLeftSHY},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Умница, Дик!", wait:1000, guideFinish:true, faceChange:stacyLookingRightMouth},
      {text:"<i>Продолжай чередовать скорость, ускоряйся, затем замедляйся и так далее</i>", wait:1500, nextStage:true},
    ]
  },
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Пожалуйста, замедлись", faceChange:stacyLookingRightMouth},
      {text:"Постарайся двигаться так медленно, как только можешь", vibration:[100,50,100], wait:1500},
      {text:"Ричард, ты здесь?", badEnd:true, faceChange:stacyLookingAtYouAngry},
    ]
  }
]
];

//SIXTH STAGE

//English
let sixthStageArrEn=[
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Yeah, just like that!", soundEffectPre:femaleMoaning7, soundEffectVolume:0.8, faceChange:stacyEyesClosed2},
      {text:"Very nice", wait:500},
      {text:"Keep going", soundEffectPre:femaleMoaning, soundEffectVolume:0.8, faceChange:stacyLookingRightMouth},
      {text:"Do you like it, Stacy?", wait:500},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Mmmph", wait:500, soundEffectPre:femaleMoaning12, soundEffectVolume:0.8, faceChange:stacyLookingRight},
      {text:"I like it, Ms. Ryder"},
      {text:"Please don't stop!", faceChange:stacyLookingAtYouMouthOpen},
      {text:"YEAH!", wait:500, soundEffectPre:femaleMoaning13, soundEffectVolume:0.8},
      {text:"I wanna cum so bad", faceChange:stacyEyesClosed},
      {text:"Oh my god!", wait:500},
      {text:"GOOOD!", vibration:[700], soundEffectPre:femaleMoaning, soundEffectVolume:0.8, faceChange:stacyLookingAtYouMouthOpen},
      {text:"I LIKE IT SO MUCH"},
      {text:"AAAHH", soundEffectPre:femaleArousal10, soundEffectVolume:0.8, faceChange:stacyLookingAtYouMouthOpenW},
      {text:"I'M GETTING CLOSER", wait:500},
      {text:"MMMMMMPH", soundEffectPre:femaleArousal9, soundEffectVolume:0.8, faceChange:stacyEyesClosed},
      {text:"I'M SO CLOOSE!", vibration:[300, 100, 500]},
      {text:"<i>NOW KEEP THE SPEED ON MAXIMUM</i>", wait:1000, nextStage:true},
    ]
  },
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"You're doing it right, but a bit too slow, try doing it faster", faceChange:stacyLookingAtYouMouthOpen2},
      {text:"<i>Richard, you should change the speed a little faster, from low to high and so on</i>", wait:1000},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Dick, do it a bit faster!", vibration:[100,50,100], wait:1000, faceChange:stacyLookingAtYouAngry},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, are you here?", badEnd:true},
    ]
  },
],
[
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Please, keep doing as I showed you", soundEffectPre:femaleMoaning12, soundEffectVolume:0.2, faceChange:stacyLookingAtYou},
      {text:"<i>Keep changing the speed from slow to fast and so on</i>", wait:1000},
    ]
  },
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"Dick, don't stop!", vibration:[100,50,100], wait:1000, faceChange:stacyLookingAtYouAngry},
    ]
  },
  {
    char:"Prof. Ryder",  position:"right",
    phrases:[
      {text:"Richard, are you here?", badEnd:true},
    ]
  },
]
];

//Russian
let sixthStageArrRu=[
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Да-а-а, вот так!", soundEffectPre:femaleMoaning7, soundEffectVolume:0.8, faceChange:stacyEyesClosed2},
      {text:"Суупер", wait:500},
      {text:"Продолжаай...", soundEffectPre:femaleMoaning, soundEffectVolume:0.8, faceChange:stacyLookingRightMouth},
      {text:"Тебе приятно так, Стейси?", wait:500},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Мммпхп", wait:500, soundEffectPre:femaleMoaning12, soundEffectVolume:0.8, faceChange:stacyLookingRight},
      {text:"Мне очень приятно, мисс Райдер"},
      {text:"Пожалуйста, Дик, только не останавливайся!", faceChange:stacyLookingAtYouMouthOpen},
      {text:"ДАА!!", soundEffectPre:femaleMoaning13, soundEffectVolume:0.8},
      {text:"Я так хочу ко-о-ончить..", faceChange:stacyEyesClosed},
      {text:"Господи!", wait:500},
      {text:"Бля-Я-яЯТЬ!", vibration:[700], soundEffectPre:femaleMoaning, soundEffectVolume:0.8, faceChange:stacyLookingAtYouMouthOpen},
      {text:"КАК ЖЕ ХОРОШО"},
      {text:"АААААХхХ", soundEffectPre:femaleArousal10, soundEffectVolume:0.8, faceChange:stacyLookingAtYouMouthOpenW},
      {text:"Я УЖЕ ПОЧТИ", wait:500},
      {text:"ММММММПХХ", soundEffectPre:femaleArousal9, soundEffectVolume:0.8, faceChange:stacyEyesClosed},
      {text:"Я ОЧЕНЬ БЛИЗКО!", vibration:[300, 100, 500]},
      {text:"<i>ДВИГАЙСЯ МАКСИМАЛЬНО БЫСТРО</i>", wait:1000, nextStage:true},
    ]
  },
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ты молодец, но ты делаешь это слишком медленно, постарайся ускорить темп", faceChange:stacyLookingAtYouMouthOpen2},
      {text:"<i>Ричард, меняй скорость немного быстрее</i>", wait:1000},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Дик, пожалуйста, немного быстрее!", vibration:[100,50,100], wait:1000, faceChange:stacyLookingAtYouAngry},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, ты здесь?", badEnd:true},
    ]
  },
],
[
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Пожалуйста, попробуй делать, как я только что показала", soundEffectPre:femaleMoaning12, soundEffectVolume:0.2, faceChange:stacyLookingAtYou},
      {text:"<i>Ричард, попробуй замедляться, а потом снова ускоряться и так далее</i>", wait:1000},
    ]
  },
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"Дик, только не останавливайся!", vibration:[100,50,100], wait:1000, faceChange:stacyLookingAtYouAngry},
    ]
  },
  {
    char:"Мисс Райдер",  position:"right",
    phrases:[
      {text:"Ричард, ты здесь?", badEnd:true},
    ]
  },
]
];

//FINAL STAGE

//English
let finalStageArrEn=[
  [
    {
      char:"Stacy",  position:"center",
      phrases:[
        {text:"YEEEEEEES!!!", vibration:[1000], soundEffectPre:femaleMoaning15, soundEffectVolume:0.8, faceChange:stacyLookingAtYouMouthOpenW},
        {text:"OH MY GOD!!", vibration:[300, 100, 500], wait:1000},
        {text:"JUST DON'T STOP"},
      ]
    },
    {
      char:"Prof. Ryder",  position:"right",
      phrases:[
        {text:"Do you feel her heat, Richard", wait:500, faceChange:stacyLookingRightMouthW},
        {text:"You made her so wet"},
      ]
    },
    {
      char:"Stacy",  position:"center",
      phrases:[
        {text:"AAAHh", wait:1500, soundEffectPre:femaleArousal10, soundEffectVolume:0.8, faceChange:stacyLookingAtYouMouthOpen},
        {text:"I'M GONNA", vibration:[700], passed:true},
      ]
    },
    {
      char:"Prof. Ryder",  position:"right",
      phrases:[
        {text:"You're gonna", faceChange:stacyLookingRightMouthW},
      ]
    },
    {
      char:"Stacy",  position:"center",
      phrases:[
        {text:"FUUUCK!", vibration:[100,50,100,50,100], wait:500, faceChange:stacyEyesClosed},
        {text:"I'M..", vibration:[100,50,100,50,100], wait:1500, soundEffectPre:femaleArousal9, soundEffectVolume:0.8},
        {text:"CUMMING!!", vibration:[100,50,150,50,200]},
        {text:"AAAAAHH", vibration:[700], wait:1000, nextStage:true, soundEffectPre:orgasm7, soundEffectVolume:0.8, faceChange:stacyLookingAtYouMouthOpenW},
      ]
    },
],
[
  {
    char:"Stacy",  position:"center",
    phrases:[
      {text:"NO NO NO NO NO!", faceChange:stacyLookingAtYouMouthOpen},
      {text:"DO IT AS FAST AS YOU CAN", wait:500},
      {text:"PLEASE, I'M SO CLOSE...", faceChange:stacyEyesClosed2},
      {text:"DON'T LET ME LOOSE IT!", vibration:[100,50,100], wait:1000},
      {text:"Fuck!", badEnd:true, faceChange:stacyLookingAtYouAngry}
    ]
  },
]
];

//Russian
let finalStageArrRu=[
  [
    {
      char:"Стейси",  position:"center",
      phrases:[
        {text:"БОЖЕ-Е-Е!!!", vibration:[1000], vibration:[1000], soundEffectPre:femaleMoaning15, soundEffectVolume:0.8, faceChange:stacyLookingAtYouMouthOpenW},
        {text:"КАК ЖЕ ОХУЕННО!!", vibration:[300, 100, 500], wait:1000},
        {text:"ТОЛЬКО НЕ ОСТАНАВЛИВАЙСЯ"},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Чувствуешь, как она этого хочет, Ричард?", wait:500, faceChange:stacyLookingRightMouthW},
        {text:"Ты так хорошо постарался"},
      ]
    },
    {
      char:"Стейси",  position:"center",
      phrases:[
        {text:"АААаХх", wait:1500, soundEffectPre:femaleArousal10, soundEffectVolume:0.8, faceChange:stacyLookingAtYouMouthOpen},
        {text:"Я СЕЙЧАС", vibration:[700], passed:true},
      ]
    },
    {
      char:"Мисс Райдер",  position:"right",
      phrases:[
        {text:"Ты сейчас", faceChange:stacyLookingRightMouthW},
      ]
    },
    {
      char:"Стейси",  position:"center",
      phrases:[
        {text:"БЛЯЯЯЯТЬ!", vibration:[100,50,100,50,100], wait:500, faceChange:stacyEyesClosed},
        {text:"Я сейчас..", vibration:[100,50,100,50,100], wait:1500, soundEffectPre:femaleArousal9, soundEffectVolume:0.8},
        {text:"М-м-мпхпф!!", vibration:[100,50,150,50,200]},
        {text:"ААаААаАхХХ", vibration:[700], wait:1000, nextStage:true, soundEffectPre:orgasm7, soundEffectVolume:0.8, faceChange:stacyLookingAtYouMouthOpenW},
      ]
    },
],
[
  {
    char:"Стейси",  position:"center",
    phrases:[
      {text:"НЕТ НЕТ НЕТ!", faceChange:stacyLookingAtYouMouthOpen},
      {text:"МАКСИМАЛЬНО БЫСТРО", wait:500},
      {text:"ПОЖАЛУЙСТА, Я ТАК БЛИЗКО...", faceChange:stacyEyesClosed2},
      {text:"ТОЛЬКО НЕ ОСТАНАВЛИВАЙСЯ!", vibration:[100,50,100], wait:1000},
      {text:"Блять!", badEnd:true, faceChange:stacyLookingAtYouAngry}
    ]
  },
]
];

export { dialogEducationFirstEn, dialogEducationEn, dialogEducationSkipEn, lowerSpeedArrEn, secondStageArrEn, thirdStageArrEn, fourthStageArrEn, fifthStageArrEn, sixthStageArrEn, finalStageArrEn, dialogEducationFirstRu, dialogEducationRu, dialogEducationSkipRu, lowerSpeedArrRu, secondStageArrRu, thirdStageArrRu, fourthStageArrRu, fifthStageArrRu, sixthStageArrRu, finalStageArrRu };
